export const getActions = ({ permissions, module }) => {
  let actions = {}
  permissions.forEach(tpm => {
    tpm.childrens.forEach(tp => {
      tp.childrens.forEach(t => {
        if (t.href_tag === module) {
          t.actions.forEach(a => {
            actions[a.field_action] = a
          })
        }
      })
    })
  })
  return actions
}

export const hasPermission = ({ permissions, module }) => {
  let has = false

  permissions.forEach(tpm => {
    if (has) {
      return false
    }

    tpm.childrens.forEach(tp => {
      if (has) {
        return false
      }

      tp.childrens.forEach(tp => {
        if (has) {
          return false
        }

        if (tp.href_tag === module) {
          has = true
        }
      })
    })
  })

  return has
}

export const filterByCompany = ({ options, super_admin_user, row }) => {
  return options.filter(t => {
    if (super_admin_user === 1) {
      if (!row.p_id_company) {
        return false;
      } else {
        return t.id_company === row.p_id_company
      }
    }

    return true;
  })
}